<template>
	<div class="full media" style="z-index:0;">
		<audio v-for="item in bgm" :key="item.name" :src='item.src' preload loop="loop" :ref="item.name"></audio>
	</div>
</template>


<style scoped>


</style>


<script>
	import {
		Howl
	} from 'howler';
	export default {
		props: {

		},
		data() {
			return {
				bgm: [{
					name: 'bgm',
					src: require('../mp3/bgm.mp3'),
				}, {
					name: 'bgm2',
					src: require('../mp3/bgm2.mp3'),
				}],
				yinxiao: [{
					name: 'addtime',
					src: require('../mp3/addtime.mp3'),
					num: 1,
				},{
					name: 'combo',
					src: require('../mp3/combo.mp3'),
					num: 1,
				},{
					name: 'flash',
					src: require('../mp3/flash.mp3'),
					num: 1,
				},{
					name: 'success',
					src: require('../mp3/success.mp3'),
					num: 1,
				},{
					name: 'selectbox',
					src: require('../mp3/selectbox.mp3'),
					num: 1,
				},{
					name: 'tap',
					src: require('../mp3/tap.mp3'),
					num: 1,
				},{
					name: 'notice',
					src: require('../mp3/notice.mp3'),
					num: 1,
				},{
					name: 'openbox',
					src: require('../mp3/openbox.mp3'),
					num: 1,
				}]
			};
		},
		computed: {
			bgmIsPlay() {
				return this.$store.state.bgmIsPlay
			},
			bgmobj() {
				return this.$store.state.bgm[this.$store.state.bgmindex]
			}
		},
		mounted() {
			this.bgmInit()
			this.yinxiaoInit()
			if (this.$tool.isWeiXin()) {
				if (this.bgmIsPlay) {
					this.bgmobj.play()
				}
				document.addEventListener("WeixinJSBridgeReady", () => {
					if (this.bgmIsPlay) {
						this.bgmobj.play()
					}
				}, false)
			} else {
				this.bgmobj.play()
			}
		},
		watch: {
			bgmIsPlay(res) {
				res ? this.bgmobj.play() : this.bgmobj.pause()
			}
		},
		methods: {
			bgmInit() {
				let arr = []
				if (this.$tool.device() == 'ios') {
					this.bgm.forEach((item) => {
						this.$refs[item.name][0].play()
						this.$refs[item.name][0].pause()
						arr.push(this.$refs[item.name][0])
					})
				} else {
					this.bgm.forEach((item) => {
						let sound = new Howl({
							src: [item.src],
							loop: true,
							onplayerror: () => {
								sound.once('unlock', () => {
									sound.play()
								})
							}
						})
						arr.push(sound)
					})
				}
				this.$store.commit('setBgm', {
					value: arr
				})
			},
			yinxiaoInit() {
				this.yinxiao.forEach((item) => {
					let arr = []
					let sound = new Howl({
						src: [item.src],
						loop: false,
						onplayerror: () => {
							sound.once('unlock', () => {
								sound.play()
							})
						}
					})
					arr.push({
						audio: sound,
						num: 0
					})
					this.$store.commit('setYinxiao', {
						name: item.name,
						audio: arr
					})
				})

			},
		},

	}
</script>
